import React, { useEffect } from 'react'
import { Link } from "react-router-dom"
import Footer from "./Footer"
import Navigation from "./Navigationnew"
import { Row, Col } from "react-bootstrap"
import { FaCheck } from "react-icons/fa"
//import aboutimg from "./Images/SSIPMT_logo.png"


const Aboutus = () => {

    ///////////////Render top/////////////////////
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    return (

        <div className="">

            <Row>
                <Navigation />
            </Row>

                        <Row className="mt-5">
                <Col xs={1}></Col>
                <Col xs>
                    <Row className="justify_content_center homfinmgmthead">
                        ABOUT US
                    </Row>
                </Col>
                <Col xs={1}></Col>
            </Row>

            <Row className="mt-5">
                <Col xs={1}></Col>
                <Col xs>
                    <Row className="homfinmgmthead justify_content_center">
                        Practical AI and Transportation Solutions for Real Business Operations
                    </Row>

                    <Row className="abtustext mt-3">
                        LNAiOs Ltd. is an Ohio-based enterprise software company helping
                        organizations automate transportation operations, document processing,
                        document management, compliance, and information retrieval.
                    </Row>

                    <Row className="abtustext mt-3">
                        Our platform brings together transportation technology, artificial
                        intelligence, document automation, workflow management, and system
                        integration to reduce manual effort and improve operational visibility.
                    </Row>

                    <Row className="abtustext mt-3">
                        We serve logistics companies, manufacturers, distributors, government
                        agencies, and other organizations managing complex transportation or
                        document-intensive processes.
                    </Row>
                </Col>
                <Col xs={1}></Col>
            </Row>

            <Row className="mt-5">
                <Col></Col>
                <Col xs={6} className="homesecondsecborder"></Col>
                <Col></Col>
            </Row>


            <Row className="footermargin  mt-5">
                <Footer />
            </Row>

        </div >
    )
}

export default Aboutus